"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _react = _interopRequireDefault(require("react"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _Text = _interopRequireDefault(require("../../Text"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var CertificationLicences = function CertificationLicences(props) {
  var _props$certificationL = props.certificationLicences,
      certificationLicences = _props$certificationL === void 0 ? [] : _props$certificationL;
  var t = (0, _useTranslation["default"])();

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return (0, _core.jsx)(_react["default"].Fragment, null, certificationLicences.map(function (licence, index) {
    return (0, _core.jsx)("div", {
      css: /*#__PURE__*/(0, _css2["default"])({
        paddingLeft: spacing(4)
      }, ";label:CertificationLicences;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9Ta2lsbHMvQ2VydGlmaWNhdGlvbkxpY2VuY2VzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFvQmUiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL1Jlc3BvbnNpdmVKb2JDYXJkL1NraWxscy9DZXJ0aWZpY2F0aW9uTGljZW5jZXMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IEZ1bmN0aW9uQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgdXNlVGhlbWUgZnJvbSAnLi4vLi4vc3R5bGVzL3VzZVRoZW1lJztcbmltcG9ydCBUZXh0IGZyb20gJy4uLy4uL1RleHQnO1xuaW1wb3J0IHVzZVRyYW5zbGF0aW9uIGZyb20gJy4uL1RyYW5zbGF0aW9uUHJvdmlkZXIvdXNlVHJhbnNsYXRpb24nO1xuXG5leHBvcnQgaW50ZXJmYWNlIENlcnRpZmljYXRpb25MaWNlbmNlc1Byb3BzIHtcbiAgY2VydGlmaWNhdGlvbkxpY2VuY2VzPzogc3RyaW5nW107XG59XG5cbmNvbnN0IENlcnRpZmljYXRpb25MaWNlbmNlczogRnVuY3Rpb25Db21wb25lbnQ8Q2VydGlmaWNhdGlvbkxpY2VuY2VzUHJvcHM+ID0gKHByb3BzKSA9PiB7XG4gIGNvbnN0IHsgY2VydGlmaWNhdGlvbkxpY2VuY2VzID0gW10gfSA9IHByb3BzO1xuICBjb25zdCB0ID0gdXNlVHJhbnNsYXRpb24oKTtcblxuICBjb25zdCB7IHNwYWNpbmcgfSA9IHVzZVRoZW1lKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8PlxuICAgICAge2NlcnRpZmljYXRpb25MaWNlbmNlcy5tYXAoKGxpY2VuY2UsIGluZGV4KSA9PiB7XG4gICAgICAgIHJldHVybiAoXG4gICAgICAgICAgPGRpdiBjc3M9e3sgcGFkZGluZ0xlZnQ6IHNwYWNpbmcoNCkgfX0ga2V5PXtpbmRleH0+XG4gICAgICAgICAgICA8VGV4dD57dChsaWNlbmNlIGFzIGFueSwgeyBkZWZhdWx0VmFsdWU6IGxpY2VuY2UgfSl9PC9UZXh0PlxuICAgICAgICAgICAgPGRpdj5cbiAgICAgICAgICAgICAgPFRleHQgdmFyaWFudD1cInBhcmFncmFwaFwiIGluYWN0aXZlPlxuICAgICAgICAgICAgICAgIHt0KCd2YWxpZCcpfVxuICAgICAgICAgICAgICA8L1RleHQ+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgKTtcbiAgICAgIH0pfVxuICAgIDwvPlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgQ2VydGlmaWNhdGlvbkxpY2VuY2VzO1xuIl19 */")),
      key: index
    }, (0, _core.jsx)(_Text["default"], null, t(licence, {
      defaultValue: licence
    })), (0, _core.jsx)("div", null, (0, _core.jsx)(_Text["default"], {
      variant: "paragraph",
      inactive: true
    }, t('valid'))));
  }));
};

__signature__(CertificationLicences, "useTranslation{t}\nuseTheme{{ spacing }}", function () {
  return [_useTranslation["default"], _useTheme2["default"]];
});

var _default = CertificationLicences;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CertificationLicences, "CertificationLicences", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Skills/CertificationLicences.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Skills/CertificationLicences.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();